
export const PHONE_PREFIX = '+84';
export const PAGE_SIZE = 10;
export const PAGE_INDEX = 1;

export const RESEND_OTP_TIME = 1;

export const PASSWORD_LENGTH_LIMIT = 8;

export const OTP_LENGTH = 6;

export const LANG_LABELS = {
    vi: 'Tiếng Việt',
    en: 'English'
};
